module.exports = __webpack_public_path__ + "static/media/broken-image.a80a0b9e.png";